/**
 * Contact Preferences Replacer View
 */

define(function(require) {
    var BaseReplacerView = require('common/base.replacer.view');
    var Form = require('class/form.class');
    var user = require('user');
    var _ = require('underscore');

    return BaseReplacerView.extend({

        className: 'contact-preferences',

        accessRules: {
            allow: ['user']
        },

        events: _.extend({}, BaseReplacerView.prototype.events, {
            'submit .fn-contact-preferences': 'handleSubmitPreferences'
        }),

        render: function() {
            this.el.innerHTML = this.tmpl('contact-preferences', user.getSubscriptions());

            this.form = new Form(this.$('.fn-contact-preferences'));

            return this;
        },

        handleSubmitPreferences: function(event) {
            const subscriptions = user.getSubscriptions();
            const formData = this.form.data();

            event.preventDefault();

            const parsedSubscriptions = subscriptions.map((item) => ({
                ...item,
                preference: Boolean(formData[item.channel])
            }));

            this.form.showLoading();
            user.setSubscriptions(parsedSubscriptions)
                .always(this.form.hideLoading.bind(this.form))
                .done(this.successRequest.bind(this))
                .fail(this.errorRequest.bind(this));
        },

        successRequest: function() {
            this.renderPopup('successUpdate');
        },

        errorRequest: function() {
            this.renderPopup('errorUpdate');
            this.render();
        },

        renderPopup: function(status) {
            window.Playtech.API.popup.showPopup({
                title: this.translate('playtech.mobile.system.contactPreferences.title'),
                content: this.translate('playtech.mobile.system.contactPreferences.' + status)
            });
        }

    }, {
        nameOfReplacers: [
            'PLAYER_CONTACT_PREFERENCES'
        ]
    });
});
